import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { AddRounded } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import routes from '@src/constants/route';
import FirstVoiceBoxImg from '@src/assets/images/create-first-voice-box.svg';
import { useDispatch } from 'react-redux';
import actions from '@src/redux/actions';
import { DEFAULT_SYNTHESIS_REQUEST } from '@src/constants/voice';
import { StyledEmptyRequest } from './index.style';

const EmptyRequest = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const onCreate = () => {
    dispatch(
      actions.synthesisRequest.updateSynthesisConfig(DEFAULT_SYNTHESIS_REQUEST),
    );
    history.push(routes.MOBILE_TTS);
  };
  return (
    <StyledEmptyRequest>
      <Box className="box">
        <img src={FirstVoiceBoxImg} alt="first-voice-box" className="image" />
        <Box>
          <Typography className="text-empty-list">
            {t('noConversionRequests')}
          </Typography>
          <Typography className="text-empty-list">
            {t('clickCreateNew')}
          </Typography>
        </Box>
        <Button
          color="primary"
          variant="contained"
          className="button"
          onClick={onCreate}
        >
          <AddRounded className="icon" />
          <Typography className="text">{t('createNew')}</Typography>
        </Button>
      </Box>
    </StyledEmptyRequest>
  );
};

export default EmptyRequest;
